function base64UrlEncode(bytes: Uint8Array): string {
  const binary = Array.from(bytes, b => String.fromCharCode(b)).join('');
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function generateCodeVerifier(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return base64UrlEncode(array);
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(verifier)
  );
  return base64UrlEncode(new Uint8Array(digest));
}

export function generateState(): string {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return base64UrlEncode(array);
}

// Session storage keys for the in-flight OAuth flow.
const PKCE_VERIFIER_KEY = 'oauth_pkce_verifier';
const OAUTH_STATE_KEY = 'oauth_state';
const REDIRECT_PATH_KEY = 'oauth_redirect_path';

function take(key: string): string | null {
  const value = sessionStorage.getItem(key);
  sessionStorage.removeItem(key);
  return value;
}

export const storePkceVerifier = (v: string) =>
  sessionStorage.setItem(PKCE_VERIFIER_KEY, v);
export const getAndClearPkceVerifier = () => take(PKCE_VERIFIER_KEY);
export const storeOAuthState = (s: string) =>
  sessionStorage.setItem(OAUTH_STATE_KEY, s);
export const getAndClearOAuthState = () => take(OAUTH_STATE_KEY);
export const storeRedirectPath = (p: string) =>
  sessionStorage.setItem(REDIRECT_PATH_KEY, p);
export const getAndClearRedirectPath = () => take(REDIRECT_PATH_KEY);
